import { css, GlobalStyles } from '@mui/material';
import { ToastContainer as ToastifyToastContainer } from 'react-toastify';
import { Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { styles } from './consts';

const toastifyOverrideStyles = css`
  ${styles};
  .Toastify {
    &__toast {
      border-radius: 0;
      padding: 12px;
      font-family: inherit;
      min-height: 76px;
    }
    &__toast-container {
      min-width: 332px;
      &--top-right {
        position: fixed;
        top: 72px;
        right: 1em;
        z-index: 10;
        max-width: 332px;
      }
    }
    &__toast-body {
      align-items: start;
      padding: 0;
      margin-top: 0;
    }
    &__toast-theme--light {
      background-color: #ffffff !important;
    }
    &__toast-icon {
      width: 24px;
      margin-left: -1px;
      margin-inline-end: 11px;
    }
    &__progress-bar--error {
      background: #e74c3c;
    }
  }
`;

export const ToastContainer = () => {
  return (
    <div className="lala">
      <GlobalStyles styles={toastifyOverrideStyles} />
      <ToastifyToastContainer
        position="top-right"
        closeOnClick
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </div>
  );
};
